import { render, staticRenderFns } from "./ProductLoading.vue?vue&type=template&id=145cf9a4&"
import script from "./ProductLoading.vue?vue&type=script&lang=js&"
export * from "./ProductLoading.vue?vue&type=script&lang=js&"
import style0 from "./ProductLoading.vue?vue&type=style&index=0&id=145cf9a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports